import axios from 'axios';
import React, {Component} from 'react';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import CustomAlert from "./CustomAlert";
import {Col, Container, Row} from "react-bootstrap";
import {removeUserSession} from "../Utils/Security";

class Upload extends Component {

    constructor(props) {
        super(props);
    }

    state = {
        selectedFile: null,
        validated: false,
        fileType: 'DELPHI',
        subUseCase: 'AUTOMATED_RIDE_SHARING',
        hasError: false,
        message: null,
        formSubmitted: false,
        submittedSuccessfully: false
    };

    // On file select (from the pop up)
    onFileChange = event => {
        this.setState({selectedFile: event.target.files[0]});
    };

    validateForm = () => {
        const renderSubUseCases = this.state.fileType === 'DELPHI';

        if (renderSubUseCases && !this.state.subUseCase) {
            return false;
        }

        return !!this.state.selectedFile && !!this.state.fileType;
    };

    submit = (event) => {
        let self = this;
        this.setState({formSubmitted: true});
        this.setState({hasError: false});
        this.setState({submittedSuccessfully: false});
        event.preventDefault();
        if (this.validateForm()) {
            const formData = new FormData();
            formData.append(
                "file",
                this.state.selectedFile,
                this.state.selectedFile.name
            );
            formData.append('fileType', this.state.fileType);
            formData.append('subUseCase', this.state.subUseCase);
            axios.post("/api/upload", formData).then(resp => {
                this.setState({submittedSuccessfully: true});
            }).catch(function (error) {
                switch (error.response.status) {
                    case 403:
                        removeUserSession();
                        window.location.href = '/login';
                        break;
                    default:
                        self.setState({hasError: true});
                        let errorMessage = error.response && error.response.data && error.response.data.length > 0 ?
                            error.response.data[0].description : 'Something went wrong. Please try again'
                        self.setState({message: errorMessage});
                        break;
                }
            });
        }
    };

    onSelectType(event) {
        this.setState({fileType: event.target.value});
    }

    onSelectSubUseCase(event) {
        this.setState({subUseCase: event.target.value});
    }

    render() {
        let alert;
        if (!this.validateForm() && this.state.formSubmitted) {
            alert = <CustomAlert variant={'danger'} message="Please select an excel file"/>
        } else if (this.state.formSubmitted && this.state.hasError) {
            alert = <CustomAlert variant={'danger'} message={this.state.message}/>
        } else if (this.state.formSubmitted && this.state.submittedSuccessfully) {
            alert =
                <CustomAlert variant={'success'} message={'The file has been uploaded and processed successfully!'}/>
        }

        return (
            <Container>
                <Form noValidate
                      validated={this.state.validated}
                      onSubmit={this.submit}>

                    <h2 className="text-center">Upload File</h2>

                    <Row>
                        <Col md={{span: 6, offset: 3}}>
                            <p className="text-center">From the below form, you can select the file type and file you
                                want to
                                upload and save!</p>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={{span: 6, offset: 3}}>
                            <Form.Group controlId="exampleForm.ControlSelect1">
                                <Form.Label>Select file type</Form.Label>
                                <Form.Control
                                    as="select"
                                    onChange={this.onSelectType.bind(this)}>
                                    <option value="DELPHI">Delphi</option>
                                    <option value="MICRO_SD">MicroSd</option>
                                    <option value="MESOSCOPIC">Mesoscopic</option>
                                    <option value="BASE_PARAMETER">Base Parameters</option>
                                    <option value="BASE_SCENARIO_PARAM">Base Scenario Parameters</option>
                                    <option value="IMPACT">Impact</option>
                                    <option value="POLICY_PARAM">Policy Parameters</option>
                                    <option value="CBA_USER_INPUT">CBA User Input</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>

                    {this.renderSubUseCases()}

                    <Row>
                        <Col md={{span: 6, offset: 3}}>
                            <Form.Group>
                                <Form.File id="uploadFile" onChange={this.onFileChange}
                                           accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                           label="Select file"/>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={{span: 6, offset: 3}}>
                            <Button block md="12" type="submit">Submit</Button>
                            {alert}
                        </Col>
                    </Row>
                </Form>
            </Container>
        );
    }

    renderSubUseCases() {
        const renderSubUseCases = this.state.fileType === 'DELPHI' || this.state.fileType === 'MICRO_SD'
            || this.state.fileType === 'MESOSCOPIC';

        if (renderSubUseCases) {
            return (
                <Row>
                    <Col md={{span: 6, offset: 3}}>
                        <Form.Group controlId="exampleForm.ControlSelect2">
                            <Form.Label>Select Sub-use case</Form.Label>
                            <Form.Control
                                as="select"
                                onChange={this.onSelectSubUseCase.bind(this)}>
                                <option value="AUTOMATED_RIDE_SHARING">Automated Ride Sharing</option>
                                <option value="CITY_TOLLS">City Tolls</option>
                                <option value="DEDICATED_LANES">Dedicated Lanes</option>
                                <option value="GLOSA">Glosa</option>
                                <option value="ON_STREET_PARKING">On Street Parking</option>
                                <option value="PARKING_PRICE">Parking Price</option>
                                <option value="AUTOMATED_CONSOLIDATION">Automated Consolidation</option>
                                <option value="AUTOMATED_DELIVERY">Automated Delivery</option>
                                <option value="HUB_2_HUB">Hub2Hub</option>
                                <option value="ON_DEMAND_SHUTTLE_BUS_SERVICE">On Demand Shuttle Bus Service</option>
                                <option value="SHUTTLE_BUS_SERVICE">Shuttle Bus Service</option>
                                <option value="SHUTTLE_LARGE_SCALE">Shuttle Large Scale Network</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
            )
        }
    }
}

export default Upload;